import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class TopDrivers extends Model {
  @Expose() id: number;
  @Expose() firstName: string;
  @Expose() lastName: string;
  @Expose() acceptances: number;

  public get name(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
